import { render, staticRenderFns } from "./dadian.vue?vue&type=template&id=098bd25c&scoped=true"
import script from "./dadian.vue?vue&type=script&lang=js"
export * from "./dadian.vue?vue&type=script&lang=js"
import style0 from "./dadian.vue?vue&type=style&index=0&id=098bd25c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bd25c",
  null
  
)

export default component.exports